<!-- <template>
  <nav ref="mainNav" class="navbar navbar-expand-lg navbar-dark">
    <div class="container-fluid">
      <router-link to="/">
        <img src="@/assets/logos/logo_navbar.png" alt="" class="navbar-logo">
      </router-link>
      <button 
        class="navbar-toggler" 
        type="button" 
        data-bs-toggle="offcanvas" 
        data-bs-target="#navbarNav" 
        aria-controls="navbarNav" 
        aria-expanded="false" 
        aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="offcanvas offcanvas-end" id="navbarNav">
        <div class="offcanvas-header">
          <button type="button" class="btn-close btn-close-white p-4" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <ul class="navbar-nav text-lg-center text-start text-4">
          <li class="nav-item" :class="{ active: isActiveRoute('/') }">
            <router-link @click="closeMenu" class="nav-link" aria-current="page" to="/" >INICIO</router-link>
          </li>
          <li 
            class="nav-item dropdown" 
            :class="{ active: isActiveRoute('/servicios'), show: showDropdown }"
            @mouseenter="onMouseEnter"
            @mouseleave="onMouseLeave">
            <a 
              class="nav-link dropdown-toggle" 
              href="#"
              role="button" 
              @click.prevent.stop="toggleDropdown"
              :aria-expanded="showDropdown">
              SERVICIOS
            </a>
            <ul 
              class="dropdown-menu dropdown-menu-dark" 
              :class="{ show: showDropdown }" 
              @click.stop
              @mouseenter="onMouseEnter"
              @mouseleave="onMouseLeave">
              <li 
                v-for="(servicio, index) in servicios"
                :key="index"
              >
                <router-link 
                  @click="handleServiceClick" 
                  class="dropdown-item"
                  :to="`/servicios/${index}`">
                  {{ servicio.name }}
                </router-link>
              </li>
            </ul>
          </li>
          <li class="nav-item" :class="{ active: isActiveRoute('/somos') }">
            <router-link @click="closeMenu" class="nav-link" aria-current="page" to="/somos" >QUIENES SOMOS</router-link>
          </li>
          <li class="nav-item" :class="{ active: isActiveRoute('/certificaciones') }">
            <router-link @click="closeMenu" class="nav-link" aria-current="page" to="/certificaciones" >CERTIFICACIONES</router-link>
          </li>
          <li class="nav-item" :class="{ active: isActiveRoute('/contacto') }">
            <router-link @click="closeMenu" class="nav-link" aria-current="page" to="/contacto" >CONTACTO</router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import bootstrap from 'bootstrap';
import { mapState } from 'vuex';

export default {
  name: 'NavBar',
  data() {
    return {
      showDropdown: false,
      isDesktop: true,
      isOffcanvasOpening: false
    }
  },
  computed: {
    ...mapState(['services']),
    servicios() {
      return this.services
    }
  },
  methods: {
    toggleDropdown() {
      // Solo en mobile (cuando no es desktop)
      if (!this.isDesktop) {
        this.showDropdown = !this.showDropdown;
      }
    },
    
    onMouseEnter() {
      if (this.isDesktop) {
        this.showDropdown = true;
      }
    },
    
    onMouseLeave() {
      if (this.isDesktop) {
        setTimeout(() => {
          this.showDropdown = false;
        }, 200); // Pequeño delay para mejor UX
      }
    },
    
    handleServiceClick() {
      this.showDropdown = false;
      this.closeMenu();
    },
    
    checkIfDesktop() {
      this.isDesktop = window.innerWidth >= 992;
    },
    
    handleClickOutside(e) {
      // No hacer nada si el offcanvas se está abriendo o si es mobile
      if (this.isOffcanvasOpening || !this.isDesktop) {
        return;
      }
      
      // No cerrar si el clic es en el dropdown, navbar-toggler o offcanvas
      if (
        e.target.closest('.dropdown') ||
        e.target.closest('.navbar-toggler') ||
        e.target.closest('.offcanvas')
      ) {
        return;
      }
      
      this.showDropdown = false;
    },
    
    isActiveRoute(path) {
      if (path === '/') return this.$route.path === '/';
      return this.$route.path.startsWith(path);
    },
    /*closeMenu() {
      const navbarNav = document.getElementById('navbarNav');
      if (navbarNav) {
        // Cierra el menú quitando la clase 'show'
        navbarNav.classList.remove('show');
      }

      // Elimina cualquier capa de fondo existente
      const backdrops = document.querySelectorAll('.offcanvas-backdrop');
      backdrops.forEach((backdrop) => backdrop.remove());

      // Restaura el scroll del body
      document.body.classList.remove('offcanvas-backdrop');
      document.body.style.overflow = '';
    },*/
    closeMenu() {
      const offcanvasEl = document.getElementById('navbarNav');
      if (!offcanvasEl) return;

      // Usa la instancia de Bootstrap si existe, o créala
      const bsOffcanvas = bootstrap.Offcanvas.getInstance(offcanvasEl) || new bootstrap.Offcanvas(offcanvasEl);
      bsOffcanvas.hide();
    },

    handleAffix() {
      const nav = this.$refs.mainNav;
      if (!nav) return;
      const prev = nav.previousElementSibling;
      const threshold = prev ? prev.clientHeight : 0;

      if (window.scrollY > threshold) {
        if (!nav.classList.contains('fixed-top')) {
          nav.classList.add('fixed-top');
          document.body.style.paddingTop = nav.offsetHeight + 'px';
        }
      } else {
        if (nav.classList.contains('fixed-top')) {
          nav.classList.remove('fixed-top');
          document.body.style.paddingTop = '';
        }
      }
    }
  },

  mounted() {
    this.handleAffix();
    this.checkIfDesktop();
    window.addEventListener('scroll', this.handleAffix, { passive: true });
    window.addEventListener('resize', () => {
      this.handleAffix();
      this.checkIfDesktop();
    });
    const offcanvasEl = document.getElementById('navbarNav');
  if (offcanvasEl) {
    offcanvasEl.addEventListener('hidden.bs.offcanvas', () => {
      const leftover = document.querySelector('.offcanvas-backdrop');
      if (leftover) leftover.remove();
    });
  }

    // Cerrar dropdown al hacer clic fuera (con un pequeño delay)
    this.$nextTick(() => {
      setTimeout(() => {
        document.addEventListener('click', this.handleClickOutside);
      }, 100);
    });
    
    
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.handleAffix);
    window.removeEventListener('resize', this.handleAffix);
    window.removeEventListener('resize', this.checkIfDesktop);
    document.removeEventListener('click', this.handleClickOutside);
  }
};

</script>
-->
<template>
  <nav ref="mainNav" class="navbar navbar-expand-lg fixed-top navbar-dark">
    <div class="container-fluid">
      <router-link to="/">
        <img src="@/assets/logos/logo_navbar.png" alt="" class="navbar-logo" />
      </router-link>

      <!-- Botón hamburguesa -->
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Menú Offcanvas -->
      <div class="collapse navbar-collapse" id="navbarNav" tabindex="-1">
        <ul class="navbar-nav text-lg-center text-start text-4">
          <li class="nav-item" :class="{ active: isActiveRoute('/') }">
            <router-link @click="closeMenu" class="nav-link" to="/">INICIO</router-link>
          </li>

          <!-- Dropdown Servicios (solo desktop) -->
          <li
            class="nav-item"
            :class="{ 
              'dropdown': isDesktop, 
              active: isActiveRoute('/servicios'), 
              show: showDropdown && isDesktop 
            }"
            @mouseenter="onMouseEnter"
            @mouseleave="onMouseLeave"
          >
            <router-link
              to="/servicios"
              class="nav-link"
              :class="{ 'dropdown-toggle': isDesktop }"
              role="button"
              @click="handleServiciosClick"
            >
              SERVICIOS
            </router-link>
            <!-- Dropdown solo visible en desktop -->
            <ul
              v-if="isDesktop"
              class="dropdown-menu dropdown-menu-dark"
              :class="{ show: showDropdown }"
              @mouseenter="onMouseEnter"
              @mouseleave="onMouseLeave"
            >
              <li v-for="(servicio, index) in servicios" :key="index">
                <router-link
                  class="dropdown-item"
                  :to="`/servicios/${index}#main-servicios`"
                  @click="handleServiceClick"
                >
                  {{ servicio.name }}
                </router-link>
              </li>
            </ul>
          </li>

          <li class="nav-item" :class="{ active: isActiveRoute('/somos') }">
            <router-link @click="closeMenu" class="nav-link" to="/somos">QUIÉNES SOMOS</router-link>
          </li>
          <li class="nav-item" :class="{ active: isActiveRoute('/certificaciones') }">
            <router-link @click="closeMenu" class="nav-link" to="/certificaciones">CERTIFICACIONES</router-link>
          </li>
          <li class="nav-item" :class="{ active: isActiveRoute('/contacto') }">
            <router-link @click="closeMenu" class="nav-link" to="/contacto">CONTACTO</router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import * as bootstrap from "bootstrap";
import { mapState } from "vuex";

export default {
  name: "NavBar",
  data() {
    return {
      showDropdown: false,
      isDesktop: window.innerWidth >= 992,
    };
  },
  computed: {
    ...mapState(["services"]),
    servicios() {
      return this.services;
    },
  },
  methods: {
    handleServiciosClick() {
      // En mobile, solo cerrar el menú y navegar
      if (!this.isDesktop) {
        this.closeMenu();
      }
      // En desktop, cerrar dropdown
      else {
        this.showDropdown = false;
      }
    },
    onMouseEnter() {
      if (this.isDesktop) this.showDropdown = true;
    },
    onMouseLeave() {
      if (this.isDesktop) this.showDropdown = false;
    },
    handleServiceClick() {
      this.showDropdown = false;
      this.closeMenu();
    },
    isActiveRoute(path) {
      if (path === "/") return this.$route.path === "/";
      return this.$route.path.startsWith(path);
    },
    closeMenu() {
      const navbarCollapse = document.getElementById("navbarNav");
      const bsCollapse = bootstrap.Collapse.getInstance(navbarCollapse);
      
      // Si el menú está abierto (tiene la clase 'show'), ciérralo
      if (navbarCollapse.classList.contains("show")) {
        if (bsCollapse) {
          bsCollapse.hide();
        } else {
          new bootstrap.Collapse(navbarCollapse, { toggle: true }).hide();
        }
      }
    },
    handleScroll() {
      const nav = this.$refs.mainNav;
        if (!nav) return;

        // Si se ha hecho scroll, fija el top en 0
        if (window.scrollY > 10) {
          nav.style.top = "0";
        } else {
          // Si vuelve al inicio, restaura el top original
          nav.style.top = "";
        }
      }
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.isDesktop = window.innerWidth >= 992;
    });
    window.addEventListener("scroll", this.handleScroll, { passive: true });
  },
};
</script>

